<template>
  <div
    class="zt-checkbox mt-3 flex h-auto w-full min-w-0 flex-grow flex-col flex-wrap"
    :class="checkboxClasses"
  >
    <div class="zt-checkbox-slot w-100 relative mb-1 flex items-center">
      <div class="zt-input-checkbox flex-inline relative mr-3 select-none">
        <input
          class="absolute z-10 h-full w-full cursor-pointer opacity-0"
          :class="[gtmClass]"
          type="checkbox"
          v-bind="$attrs" v-on="$listeners" @change="toggleValue"
          :value="modelValue"
          :checked="isChecked"
          :id="componentId"
        />
        <zt-icon
          class="zt-checkbox-icon w-full"
          :name="iconName"
          :class="[rippleClass]"
        />
        <div
          class="zt-checkbox-ripple pointer-events-none absolute cursor-pointer overflow-hidden rounded-full"
          :class="rippleClass"
        />
      </div>
      <label
        class="zt-checkbox-label flex-inline mb-0 h-auto flex-auto cursor-pointer select-none items-center"
        :for="componentId"
      >
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztCheckBox',
  inheritAttrs: false,
}
</script>

<style
  scoped
  lang="css"
  src="../../../../styles/components/ztCheckBox.css"
></style>
